define.alias("shared/components/shared/social/instagram-modal", "calendar/components/shared/social/instagram-modal");